import type { GoldenVectorWorkflowsUiOutcome } from "@excellent/core/verification-domain-schemas";
import { ToneBadge } from "../ui";

type GoldenVectorFinding = {
  reasonCode: string;
  fixturePath: string;
  status: string;
  result: string | null;
  uiOutcome: GoldenVectorWorkflowsUiOutcome;
  summary: string;
};

export function GoldenVectorReasonCard({
  finding,
  reason,
}: {
  finding: GoldenVectorFinding | null;
  reason: string;
}) {
  if (!finding) {
    return (
      <div className="vp-card" data-golden-vector-reason={reason} data-golden-vector-status="UNKNOWN">
        <div className="vp-card-head">
          <div>
            <div className="vp-card-title">Golden-vector finding</div>
            <div className="vp-card-sub">No registry fixture is mapped for {reason}.</div>
          </div>
          <ToneBadge tone="fail">UNKNOWN</ToneBadge>
        </div>
      </div>
    );
  }
  return (
    <div
      className="vp-card"
      data-golden-vector-reason={finding.reasonCode}
      data-golden-vector-status={finding.status}
      data-golden-vector-ui-outcome={finding.uiOutcome.stateKey}
      data-golden-vector-remediation={finding.uiOutcome.remediation}
      data-golden-vector-review-case-status={finding.uiOutcome.reviewCaseStatus}
      data-golden-vector-credential-health={finding.uiOutcome.credentialHealth}
      data-golden-vector-badge-tone={finding.uiOutcome.uiBadge.tone}
    >
      <div className="vp-card-head">
        <div>
          <div className="vp-card-title">Golden-vector finding</div>
          <div className="vp-card-sub">
            <span className="vp-mono">{finding.reasonCode}</span>
          </div>
        </div>
        <ToneBadge tone={finding.status === "PASS"
          ? "pass"
          : finding.status === "FAIL" || finding.status === "MISMATCH"
            ? "fail"
            : "unknown"}>
          <span>{finding.status}</span>
        </ToneBadge>
      </div>
      <div className="vp-card-body">
        <div className="vp-fields">
          <div className="vp-field">
            <div className="vp-field-label">Fixture</div>
            <div className="vp-field-value">
              <span className="vp-mono">{finding.fixturePath}</span>
            </div>
          </div>
          {finding.result ? (
            <div className="vp-field">
              <div className="vp-field-label">Expected result</div>
              <div className="vp-field-value">{finding.result}</div>
            </div>
          ) : null}
          <div className="vp-field">
            <div className="vp-field-label">Remediation</div>
            <div className="vp-field-value">
              <span className="vp-mono">{finding.uiOutcome.remediation}</span>
            </div>
          </div>
        </div>
        <div className="vp-callout" data-tone="neutral">
          <div className="vp-callout-title">Rendered from the golden-vector registry</div>
          <div className="vp-callout-body">{finding.summary}</div>
        </div>
      </div>
    </div>
  );
}
